import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .filter-title {
        color: #002138;
        font-size: 14px;
        line-height: 20px;
        font-weight: 600;
        text-align: center;
        width: 100%;
        padding: 12px 0;
      }
      .filter-block{
        display: flex;
        flex-direction: column;
        gap: 8px;
        position: relative;
        width: 100%;
        height: 100%;
      }
      .filter-list{
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-basis: 1%;
        overflow-y: auto;
      }

      .filter-actions{
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 8px;
      }
    `,
  ],
  template: `
    <div class="filter-block">
      <div class="filter-title">Filter by Investing Entity</div>
      <mat-selection-list [formControl]="filters" class="filter-list">
        <mat-list-option
          *ngFor="let item of context.menu"
          [value]="item"
          checkboxPosition="before"
        >
          {{ item.name }}
        </mat-list-option>
      </mat-selection-list>
      <div class="filter-actions">
        <button
          type="submit"
          mat-stroked-button
          color="primary"
          class="mr-2"
          (click)="reset($event)"
        >
          Reset
        </button>
        <button
          type="submit"
          mat-stroked-button
          color="primary"
          class=""
          (click)="filter($event)"
        >
          Filter
        </button>
      </div>
    </div>
  `,
})
export class LpAssetMobileFilterComponent implements OnInit {
  allFilters: boolean = true;
  filters = new FormControl([]);

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<LpAssetMobileFilterComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public context
  ) {}

  ngOnInit(): void {
    this.filters.setValue(this.context.selected, { emitEvent: false });

    this.filters.valueChanges.subscribe((selected) => {
      const showAll = selected?.some((item) => item.id == null);
      const size = selected?.length;

      if (!showAll) {
        if (!size) {
          this.selectAll();
          return;
        }
      } else {
        if (!this.allFilters) {
          this.selectAll();
          return;
        } else {
          if (size == 1) return;

          this.allFilters = false;
          this.filters.setValue(
            [...selected.filter((item) => item !== this.context.allSelected)],
            { emitEvent: false }
          );
        }
      }
    });
  }

  private selectAll() {
    this.allFilters = true;
    this.filters.setValue([this.context.allSelected], { emitEvent: false });
  }

  reset(event: MouseEvent): void {
    this._bottomSheetRef.dismiss([this.context.allSelected]);
    event.preventDefault();
  }

  filter(event: MouseEvent): void {
    this._bottomSheetRef.dismiss(this.filters.value);
    event.preventDefault();
  }
}
